import { createFileRoute } from "@tanstack/react-router";
import AmeriHealthInsurance from "@/pages/AmeriHealthInsurance";
export const Route = createFileRoute("/amerihealth-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "AmeriHealth Insurance TMS & SPRAVATO® Coverage | Neuro Wellness FL",
        },
        {
          name: "description",
          content:
            "Learn how AmeriHealth Insurance policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "AmeriHealth Insurance TMS & SPRAVATO® Coverage | Neuro Wellness FL",
        },
        {
          property: "og:description",
          content:
            "Learn how AmeriHealth Insurance policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/amerihealth-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/amerihealth-insurance",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AmeriHealthInsurance />;
}
